import { researcherError } from './researchers.error';
import { z } from 'zod';
import { dto } from '../dto.util';

export const createResearcherDtoSchema = z.object({
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
  email: z.string().email('Invalid email format'),
  role: z.enum(['admin', 'researcher']),
});
export type CreateResearcherDto = z.infer<typeof createResearcherDtoSchema>;

export const updateResearcherDtoSchema = z.object({
  firstName: z.string().nonempty().optional(),
  lastName: z.string().nonempty().optional(),
  email: z.string().email().optional(),
  role: z.enum(['admin', 'researcher']).optional(),
});
export type UpdateResearcherDto = z.infer<typeof updateResearcherDtoSchema>;

export const researcherSchema = z.object({
  id: z.string().uuid(),
  auth0Id: z.string(),
  email: z.string().email(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  role: z.enum(['admin', 'researcher']),
  createdAt: z
    .string()
    .datetime()
    .transform((date) => new Date(date)),
  updatedAt: z
    .string()
    .datetime()
    .transform((date) => new Date(date)),
});

export type Researcher = z.infer<typeof researcherSchema>;

export const researcherDtoSchema = dto(researcherSchema, researcherError);
export type ResearcherDto = z.input<typeof researcherDtoSchema>;
